import { SET_RENDER_SETTINGS } from './types';

export function setRenderSettings(data) {
	return {
		type: SET_RENDER_SETTINGS,
		payload: data
	};
}
